import React, { useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useLocation, useNavigate } from 'react-router-dom';

import './report.css';
import './reportA4PDF.css'
import './reportLetterPDF.css';

import PrintA4ReportImage from '../images/printer-img.png';
import PrintLetterReportImage from '../images/printer-letter-img.png';

import ReportContent from './ReportContent';

const Report = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const {
        pscore,
        apProbability,
        metastasesProb,
        pcsmProb,
        percentile,
        formData,
    } = location.state || {};

    const contentRef = useRef();

    const [useLetter, setUseLetter] = useState(false);
    const [showHelp, setShowHelp] = useState(false); // State for help panel

    const handlePrintA4 = useReactToPrint({
        contentRef: contentRef,
        pageStyle: `
        @page { 
            size: A4; 
            margin: 0.2cm 0.2cm 0.4cm 0.2cm; 
        }
    `,       
        
    });

    const handlePrintLetter = useReactToPrint({
        contentRef: contentRef,
        pageStyle: `
        @page { 
            size: letter;  
            margin: 0.1in 0.20in 0.2in 0.20in; 
        }
    `,
    });

    if (
        pscore === null || pscore === undefined ||
        !apProbability ||
        !metastasesProb ||
        !pcsmProb ||
        !formData 
    ) {
        return <p>No sufficient data available to display the report.</p>;
    }








    const printLetterFormat = () => {
        setUseLetter(true); // Add the letter class dynamically

        setTimeout(() => {
            console.log('ContentRef is:', contentRef.current);
            const contentElement = contentRef.current;

            if (contentElement) {
                // Add a letter-specific class for print
                contentElement.classList.add('letter-print');
                console.log('Class added:', contentElement.className);
            }

            handlePrintLetter();

            // Cleanup: Remove the class and reset state
            setTimeout(() => {
                if (contentElement) {
                    contentElement.classList.remove('letter-print');
                }
                setUseLetter(false);
            }, 1000);
        }, 500);
    };

    const toggleHelp = () => {
        setShowHelp(prev => !prev);
    };

      // 2) "New Input" button click => navigate("/")
    const handleNewInputClick = () => {
        navigate('/');
    };

    return (

        <div className={useLetter ? 'letter-format' : ''}>
            <div className="print-button-wrapper">
                <button className="print-A4-report-button" onClick={() => handlePrintA4()}>
                    <img src={PrintA4ReportImage} alt="Save as PDF (A4)" className="print-A4-report-button" />
                </button>
                <button className="print-letter-report-button" onClick={printLetterFormat}>
                    <img src={PrintLetterReportImage} alt="Save as PDF (Letter)" className="print-letter-report-button" />
                </button>
            </div>

            <div className='top-right-buttons'>

                <button 
                    className="btn-new-patient has-tooltip" 
                    onClick={handleNewInputClick}
                    data-tooltip="Start a new report for another patient"
                    >
                    New Patient
                </button>


                <button className="help-button" onClick={toggleHelp}>
                        Help
                </button>

                    {showHelp && (
                        <div className="help-panel">
                            <h3>How to Remove Headers and Footers</h3>
                            <p>When you print from a browser, it often adds extra text like page numbers, the date, or the URL. To remove these:</p>
                            <ul>
                                <li><strong>Chrome/Edge:</strong> Open print dialog, go to "More Settings" and uncheck "Headers and Footers".</li>
                                <li><strong>Firefox:</strong> Open print dialog, click "Page Setup", and set all Header/Footer fields to blank.</li>
                                <li><strong>Safari (macOS):</strong> Uncheck "Print headers and footers" in the print dialog.</li>
                            </ul>
                            <p>After adjusting these settings, print or save as PDF again, and the extra text will be gone.</p>
                        </div>
                    )}
            </div>




            <ReportContent
                ref={contentRef}
                pscore={pscore}
                apProbability={apProbability}
                metastasesProb={metastasesProb}
                pcsmProb={pcsmProb}
                percentile={percentile}
                formData={formData}
            />
        </div>
    );
};

export default Report;
